import { z } from 'zod/v4'

const browserFileSchema = z.custom<File>(
  (value) => typeof File !== 'undefined' && value instanceof File,
  'Choose an image to upload'
)
const optionalBrowserFileSchema = z
  .custom<File | null | undefined>(
    (value) => value == null || (typeof File !== 'undefined' && value instanceof File),
    'Choose an image to upload'
  )
  .optional()
  .nullable()

export const stockImageSchema = z.object({
  file: optionalBrowserFileSchema,
  title: z.string().max(120, 'Title must be 120 characters or fewer').optional().nullable(),
  description: z
    .string()
    .max(1000, 'Description must be 1000 characters or fewer')
    .optional()
    .nullable(),
  is_published: z.boolean(),
  tag_ids: z.array(z.number()).default([]),
  occasion_ids: z.array(z.number()).default([]),
  season_ids: z.array(z.number()).default([]),
})

export const stockImageCreateSchema = stockImageSchema.extend({
  file: browserFileSchema,
})

export const stockImageTagSchema = z.object({
  label: z.string().trim().min(1, 'Tag name is required').max(80, 'Tag name is too long'),
  description: z.string().max(500, 'Description must be 500 characters or fewer').optional(),
})

export const stockImageParamsSchema = z.object({
  stockImageId: z.coerce.number().int().positive(),
})
